<template>
  <div>
    <div class="third-rea cardsmanage">
      <div class="third-btn">
        <div class="btn-left">检索条件</div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="search()">查询</el-button>
          <el-button class="btn-two" type="default" @click="resetForm('formInline')">重置</el-button>
          <span class="btn-shu"></span>
        </div>
      </div>
      <div class="third-search">
        <el-form :inline="true" :model="formInline" label-width="76px" ref="formInline">
          <div class="search-row">
            <div class="row-item">
              <el-form-item label="卡片名称" prop="cardName">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model.trim="formInline.cardName"
                  @keyup.enter.native="search"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="卡片状态" prop="status">
                <el-select class="item-input" v-model="formInline.status" placeholder="请选择">
                  <el-option label="全部" :value='null'></el-option>
                  <el-option
                    v-for="(items, index) in pointList"
                    :key="index"
                    :value="items.value"
                    :label="items.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="cardsBody">
      <div class="cardsList">
        <!-- <el-row :gutter="20"> -->
          <div class="cardsList-item" v-for="(item, key) in cardList" :key="key">
            <el-card
              class="addCard"
              :body-style="{ padding: '0px' , width:'280px' , height:'180px' , backgroundColor:'#ECECEC'}"
            >
              <div class="cards-body" style="width:280px;height:136px;">
                <!-- <img
                  src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
                  class="image"
                /> -->
                <span class="cardClass">{{item.cardName}}</span>
              </div>
              <div style="padding: 10px 14px 10px;background-color:#fff;">
                <div class="bottom clearfix">
                  <el-button class="button" type="text" @click="checkItem(item.id)">详情</el-button>
                  <el-button class="button" type="text" :disabled="item.status === 1" @click="redactItem(item.id)" >编辑</el-button>
                  <el-button class="button" type="text" @click="uninstallFN(item)" :disabled="item.status === 1">卸载</el-button>
                  <el-switch :disabled="item.isDeleted==1" v-model="item.status" :active-value="1" :inactive-value="0" @change="changeFN(item)" :width="45" style="float:right;margin-top:4px;"></el-switch>
                </div>
              </div>
            </el-card>
          </div>
          <div class="cardsList-item" :span="6">
            <el-card
              class="addCard addCard2"
              :body-style="{ padding: '0px' , width:'280px' , height:'180px' , backgroundColor:'#ECECEC'}"
            >
              <i class="el-icon-plus addicon" @click="addItem"></i>
              <p>新增</p>
            </el-card>
          </div>
        <!-- </el-row> -->
      </div>
    </div>
    <new-notice-modal
      :noticeModalVisible="noticeModal_XJ"
      :noticeTitle="noticeTitle_XJ"
      :noticeType="noticeType_XJ"
      :noticeContent="noitceContent_XJ"
      :noticeSpec="noticeSpec_XJ"
    >
      <template v-slot:footer>
        <template>
          <el-button class="modal-footer-two" @click="noticeModal_XJ = false">取消</el-button>
          <el-button class="modal-footer-two" type="primary" @click="stopFN()">确定</el-button>
        </template>
      </template>
    </new-notice-modal>
    <new-notice-modal
      :noticeModalVisible="noticeModal_QD"
      :noticeTitle="noticeTitle_QD"
      :noticeType="noticeType_QD"
      :noticeContent="noitceContent_QD"
      :noticeSpec="noticeSpec_QD"
    >
      <template v-slot:footer>
        <template>
          <el-button class="modal-footer-two" @click="noticeModal_QD = false">取消</el-button>
          <el-button class="modal-footer-two" type="primary" @click="startFN()">确定</el-button>
        </template>
      </template>
    </new-notice-modal>
    <new-notice-modal
      :noticeModalVisible="noticeModal_XZ"
      :noticeTitle="noticeTitle_XZ"
      :noticeType="noticeType_XZ"
      :noticeContent="noitceContent_XZ"
      :noticeSpec="noticeSpec_XZ"
    >
      <template v-slot:footer>
        <template>
          <el-button class="modal-footer-two" @click="noticeModal_XZ = false">取消</el-button>
          <el-button class="modal-footer-two" type="primary" @click="uninstallFN_qr()">确定</el-button>
        </template>
      </template>
    </new-notice-modal>
  </div>
</template>

<script>
import { select,stop,start,uninstall } from "@/api/cardsManage/cards";
export default {
  name: "cards",
  components: {},
  data() {
    return {
      noticeModal_XZ: false, // 提示弹窗
      noticeType_XZ: 1, // 提示类型
      noitceContent_XZ: "，确定卸载吗？", // 提示信息
      noticeTitle_XZ: "提示", // 提示
      noticeSpec_XZ: "卸载后不可恢复", // 标红提示
      //------------
      noticeModal_QD: false, // 提示弹窗
      noticeType_QD: 1, // 提示类型
      noitceContent_QD: "请再次确定应用卡片的可用性", // 提示信息
      noticeTitle_QD: "提示", // 提示
      noticeSpec_QD: "", // 标红提示
      //------------
      noticeModal_XJ: false, // 提示弹窗
      noticeType_XJ: 1, // 提示类型
      noitceContent_XJ: "，确定下架吗？", // 提示信息
      noticeTitle_XJ: "提示", // 提示
      noticeSpec_XJ: "下架后，用户将不可见该应用卡片", // 标红提示
      //------------
      item:"",
      change:false,
      formInline: {
        cardName: "", // 序号
        status: null // 状态
      },
      pointList: [
        {
          value: 1,
          label: "启用"
        },
        {
          value: 0,
          label: "停用"
        }
      ], //API状态下拉框
      cardList: [
        // { stats: true },
        // { stats: true },
        // { stats: true },
        // { stats: true }
      ]
    };
  },
  computed: {},
  mounted() {
    this.selectList();
  },
  methods: {
    //卸载
    uninstallFN(item){
      this.noticeModal_XZ=true
      this.item=item
    },
    //确认卸载
    uninstallFN_qr(){
        try{
            const params={
            id:this.item.id
                }
                uninstall(params).then(res=>{
                  const data=res.data
                  if(data.status===1000){
                    this.$message.success("操作成功")
                    this.selectList()
                  }else{
                    this.$message.error(data.msg)
                  }
                })
              }catch(err){console.log(err)}
               this.noticeModal_XZ=false
    },
    //开关
    changeFN(item){
      console.log(item)
      this.item=item
      item.status=item.status?0:1
      if(item.status===1){
        // this.stopFN(item.id)
        this.noticeModal_XJ=true
      }else if(item.status===0){
        this.noticeModal_QD=true
        // this.startFN(item.id)
      }
    },
    //停止
    stopFN(){
      try{
        const params={
          id: this.item.id
        }
        stop(params).then(res=>{
          const data=res.data
          if(data.status===1000){
            this.$message.success("操作成功")
            this.cardList.forEach(item=>{
              if(item.id==this.item.id){
                item.status=0
              }
            })
          }else{
            this.$message.error(data.msg)
          }
        })
      }catch(err){console.log(err)}
       this.noticeModal_XJ=false
    },
    //启动
    startFN(){
      try{
        const params={
          id: this.item.id
        }
        start(params).then(res=>{
          const data=res.data
          if(data.status===1000){
             this.$message.success("操作成功")
             this.cardList.forEach(item=>{
              if(item.id==this.item.id){
                item.status=1
              }
            })
          }else{
            this.$message.error(data.msg)
          }
        })
      }catch(err){console.log(err)}
       this.noticeModal_QD=false
    },
    //查询
    search() {
      console.log(this.formInline);
      this.selectList();
    },
    //表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      //   this.formInline.dataFrom = "";
      //   this.formInline.status = "";
      console.log("重置", this.formInline);
      this.search();
    },
    // 新增
    addItem() {
      console.log("新增");
      this.$emit("add");
    },
    //详情
    checkItem(row) {
      console.log("详情",row);
      this.$emit("check", row);
    },
    //编辑
    redactItem(row) {
      console.log("编辑");
      this.$emit("redact", row);
    },
    //获取列表
    selectList() {
      try {
        const params = {
          cardName: this.formInline.cardName, //卡片名称
          status: this.formInline.status //卡片状态,0下架,1上架
        };
        select(params).then(res => {
          const data = res.data;
          console.log("这是轮播图管理接口", data);
          if (data.status === 1000) {
            this.cardList = data.result;
            // this.cardList.forEach(element => {
            //   if (element.status === 0) {
            //     element.stats = false;
            //   } else {
            //     element.stats = true;
            //   }
            // });
            // this.tot = data.result.total;
            console.log("this.cardList",this.cardList)
          } else {
            this.cardList = [];
            // this.tot = 0;
          }
        });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss">
.third {
  // .cardsmanage {
  // }
  .cardsBody {
    height: calc(100vh - 84px);
    background-color: #f7f8fa;
    padding: 26px;
    overflow-y: auto;
    .cardsList{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      &-item{
        margin-right: 30px;
        // width: 20%;
      }

    }
    .time {
      font-size: 13px;
      color: #999;
    }

    .bottom {
      line-height: 12px;
    }

    .button {
      padding: 0;
      font-size: 14px;
    }

    .image {
      width: 100%;
      height: 100%;
      display: block;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }

    .clearfix:after {
      clear: both;
    }
    .addCard2{
      .el-card__body{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
    .addCard {
      background-color: #f7f8fa;
      margin-bottom: 26px;
      .addicon {
        width: 64px;
        height: 64px;
        font-weight: 800;
        font-size: 64px;
        color: #8194b2;
        // margin-top: 60px;
        // margin-left: 93px;
        // cursor: pointer;

      }
      p {
        color: #333333;
        font-size: 18px;
        font-weight: 700;
        // margin-left: 108px;
      }
      .cardClass{
          float: left;
      }
      .cards-body{
        display: flex;
        align-items: center;
        justify-content: center;
          // position: relative;
          .cardClass{
              // position: absolute;
              // top: 40%;
              // left: 35%;
              width: 200px;
              text-align: center;
              font-size: 18px;
              font-weight: 600;
          }
      }
    }
  }
}
</style>
